(function () {
  /**
   * @deprecated - please use src2/core/models/directory/DirectorySamlConfig.js
   *
   * @ngdoc factory
   * @name binky.core.directories:DirectorySamlConfig
   * @description model to fetch the SamlConfig for an owned directory
   */
  angular
    .module('binky.core.directories')
    .factory('DirectorySamlConfig', getDirectorySamlConfigModel);

  /* @ngInject */
  function getDirectorySamlConfigModel(
    $q,
    $rootScope,
    _,
    binkySrc2,
    DIRECTORY_EVENT,
    DIRECTORY_SAML_CONFIG_CACHE_ID,
    DIRECTORY_SAML_CONFIG_EVENT,
    feature,
    jilDirectories,
    modelCache,
    promiseUtils
  ) {
    class DirectorySamlConfig {
      /**
       * @description instantiate a DirectorySamlConfig object.
       * @param {Object} options - options to config the new DirectorySamlConfig.
       * @param {String} [options.directoryId] - id of the directory.
       * @param {String} [options.orgId] - id of the org to associate this with.
       * @param {String} [options.tenantId] - tenantId of the directory.
       */
      constructor(options) {
        _.assignIn(this, _.pick(options, ['directoryId', 'orgId', 'tenantId']));
      }

      getCertificateFileData() {
        if (_.isNil(this.idpCertificateFileData)) {
          return undefined;
        }
        return new Blob([this.idpCertificateFileData], {
          type: 'application/x-pem-file,application/pkix-cert,application/x-x509-ca-cert',
        });
      }

      /**
       * @description get tenant metadata.
       * @returns {Promise} resolves when Tenant Metadata is loaded.
       */
      getTenantMetadata() {
        return jilDirectories.samlConfig.getTenantMetadata(
          _.omitBy(
            {
              directoryId: this.directoryId,
              orgId: this.orgId,
              tenantId: this.tenantId,
            },
            _.isUndefined
          )
        ).$promise;
      }

      isNew() {
        return _.isNil(this.idpCertificateFileData);
      }

      /**
       * @description Method to return the current unique key for this SAML config.
       *
       * @returns {String} key to uniquely identify this object
       */
      key() {
        return getKey(this.directoryId, this.tenantId);
      }

      /**
       * @description reload the SAML config.
       * @returns {Promise} resolved when SAML config is loaded.
       */
      refresh() {
        this.$resolved = false;
        this.$promise = $q((resolve, reject) => {
          jilDirectories.samlConfig.get(
            _.omitBy(
              {
                directoryId: this.directoryId,
                orgId: this.orgId,
                tenantId: this.tenantId,
              },
              _.isUndefined
            ),
            onSuccess.bind(this),
            onError.bind(this)
          );

          function onError(error) {
            this.$resolved = true;
            reject(error);
          }
          function onSuccess(resource) {
            applyResource(this, resource);
            modelCache.put(DIRECTORY_SAML_CONFIG_CACHE_ID, this, this.key());

            this.$resolved = true;
            resolve(this);
          }
        });

        return this.$promise;
      }

      /**
       * @description create a SAML configuration.
       * @param {Object} options - configuration object.
       * @param {File} options.idpCertificateFileData - cert file.
       * @param {String} options.idpLoginUrl - login url.
       * @param {String} options.idpIssuer - IdP Issuer.
       * @param {String} options.idpBinding - either "HTTP-POST" or "HTTP-REDIRECT".
       * @param {String} options.userLoginSetting - either "email" or "username".
       * @returns {Promise} resolved with the newly configured model when create config completes.
       */
      save(options) {
        this.$resolved = false;
        const reqObj = transformRequest(options);
        this.$promise = $q((resolve, reject) => {
          jilDirectories.samlConfig.save(
            _.omitBy(
              {
                action: this.isNew() ? '' : ':update',
                directoryId: this.directoryId,
                orgId: this.orgId,
                tenantId: this.tenantId,
              },
              _.isUndefined
            ),
            reqObj,
            onSuccess.bind(this),
            onError.bind(this)
          );

          function onError(error) {
            this.$resolved = true;
            reject(error);
          }
          function onSuccess(resource) {
            applyResource(this, resource);
            modelCache.put(DIRECTORY_SAML_CONFIG_CACHE_ID, this, this.key());
            $rootScope.$emit(DIRECTORY_SAML_CONFIG_EVENT.UPDATE);
            resolve(this);
            this.$resolved = true;
          }
        });

        return this.$promise;
      }

      /**
       * @description returns plain JSON object containing only API relevant fields.
       * @returns {Object} saml config object.
       */
      toMinimumModel() {
        return toMinimumObject(this);
      }

      /**
       * @description creates a new DirectorySamlConfig object from fetched data
       * @param {Object} options - options to configure new DirectorySamlConfig
       * @param {String} [options.directoryId] - ID of the directory to fetch config for
       * @param {String} [options.tenantId] - ID of the tenant to fetch config for
       * @returns {DirectorySamlConfig} new DirectorySamlConfig from fetched resource
       */
      static get(options) {
        let model = new DirectorySamlConfig(options);

        const cachedModel = modelCache.get(DIRECTORY_SAML_CONFIG_CACHE_ID, model.key());
        if (cachedModel) {
          model = cachedModel;
        } else {
          model.refresh();
        }
        return model;
      }
    }

    class DirectorySamlConfig2 extends binkySrc2.models.directory.DirectorySamlConfig {
      constructor(options = {}) {
        super(options);
      }

      getTenantMetadata() {
        this.$resolved = false;
        this.$promise = promiseUtils
          .toAngularPromise(super.getTenantMetadata())
          .then((model) => model)
          .catch((error) => $q.reject(error.response))
          .finally(() => {
            this.$resolved = true;
          });
        return this.$promise;
      }

      refresh() {
        this.$resolved = false;
        this.$promise = promiseUtils
          .toAngularPromise(super.refresh())
          .then(() => this)
          .catch((error) => $q.reject(error.response))
          .finally(() => {
            this.$resolved = true;
          });
        return this.$promise;
      }

      save(options) {
        this.$resolved = false;
        this.$promise = promiseUtils
          .toAngularPromise(super.save(options))
          .then((model) => model)
          .catch((error) => $q.reject(error.response))
          .finally(() => {
            this.$resolved = true;
          });
        return this.$promise;
      }

      static get(options) {
        const model = new DirectorySamlConfig2(options);

        const promise = super.get(options);
        model.$resolved = false;
        model.$promise = promiseUtils
          .toAngularPromise(promise)
          .then((config) => {
            _.assign(model, config);
            return model;
          })
          .catch((error) => $q.reject(error.response))
          .finally(() => {
            model.$resolved = true;
          });

        return model;
      }
    }

    // eslint-disable-next-line angular/on-watch
    $rootScope.$on(DIRECTORY_EVENT.REFRESH, (event, directory) => {
      const tenantId = _.get(directory, 'tenantInfo.imsTenantInfo.id');
      modelCache.remove(DIRECTORY_SAML_CONFIG_CACHE_ID, getKey(directory.directoryId, tenantId));
    });

    // We register the cache size for this class
    modelCache.register(DIRECTORY_SAML_CONFIG_CACHE_ID, 1);

    return feature.isEnabled('temp_port_directorysamlconfig')
      ? DirectorySamlConfig2
      : DirectorySamlConfig;

    function getKey(directoryId, tenantId) {
      return `${directoryId}/${tenantId}`;
    }

    function applyResource(directory, resource) {
      _.assignIn(directory, toMinimumObject(resource));
      return directory;
    }

    function toMinimumObject(object) {
      return _.pick(object, [
        'idpBinding',
        'idpCertificateFileData',
        'idpIssuer',
        'idpLoginUrl',
        'userLoginSetting',
      ]);
    }

    function transformRequest(data) {
      const fd = new FormData();
      fd.append(
        'tenantConfig',
        angular.toJson(
          _.pick(data, ['idpLoginUrl', 'idpIssuer', 'idpBinding', 'userLoginSetting', 'tenantId'])
        )
      );
      fd.append('samlCertFile', _.get(data, 'idpCertificateFileData'));
      return fd;
    }
  }
})();
